module.exports = __webpack_public_path__ + "static/screenshot-3fca50d9188eb8e5dc254df842636058.png";